/* === AmourPrint CRO confetti v3 (fires on cart/add ajax + click) === */
(function(){
  var last=0;
  function fire(){
    if(window.__apConf)return; window.__apConf=true;
    var c=document.createElement('canvas');
    c.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;';
    (document.body||document.documentElement).appendChild(c);
    var x=c.getContext('2d'); c.width=innerWidth; c.height=innerHeight;
    var cols=['#0F8A6C','#15C39A','#FAD4DC','#F2A8B5','#FFC107','#ffffff'];
    var P=[],N=150;
    for(var i=0;i<N;i++){ P.push({x:innerWidth/2,y:innerHeight*0.28,vx:(Math.random()-0.5)*14,vy:Math.random()*-14-4,g:0.34+Math.random()*0.22,s:5+Math.random()*6,c:cols[i%cols.length],r:Math.random()*6,vr:(Math.random()-0.5)*0.5,a:1}); }
    var t0=Date.now();
    (function f(){
      x.clearRect(0,0,c.width,c.height); var alive=false;
      for(var i=0;i<P.length;i++){ var p=P[i]; p.vy+=p.g; p.x+=p.vx; p.y+=p.vy; p.r+=p.vr; p.a-=0.011;
        if(p.a>0 && p.y<c.height+30){ alive=true; x.save(); x.globalAlpha=Math.max(0,p.a); x.translate(p.x,p.y); x.rotate(p.r); x.fillStyle=p.c; x.fillRect(-p.s/2,-p.s/2,p.s,p.s*0.6); x.restore(); } }
      if(alive && Date.now()-t0<2600) requestAnimationFrame(f); else { c.remove(); window.__apConf=false; }
    })();
  }
  function toast(){
    var d=document.createElement('div'); d.textContent='🎉 Added to cart!';
    d.style.cssText='position:fixed;top:16%;left:50%;transform:translateX(-50%);z-index:2147483647;background:#0F8A6C;color:#fff;padding:10px 18px;border-radius:24px;font-size:15px;font-weight:600;box-shadow:0 4px 16px rgba(0,0,0,.25);opacity:0;transition:opacity .3s;pointer-events:none;';
    (document.body||document.documentElement).appendChild(d);
    requestAnimationFrame(function(){ d.style.opacity='1'; });
    setTimeout(function(){ d.style.opacity='0'; setTimeout(function(){ if(d.parentNode)d.parentNode.removeChild(d); },400); },2200);
  }
  function celebrate(){ var n=Date.now(); if(n-last<1500)return; last=n; fire(); toast(); }
  try{ var of=window.fetch; if(of){ window.fetch=function(){ var u=''; try{ u=(arguments[0]&&arguments[0].url)?arguments[0].url:(''+arguments[0]); }catch(e){} var pr=of.apply(this,arguments); try{ if(/\/cart\/add/i.test(u)) pr.then(function(){ setTimeout(celebrate,50); }).catch(function(){}); }catch(e){} return pr; }; } }catch(e){}
  try{ var oo=XMLHttpRequest.prototype.open, os=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(m,u){ this.__apu=(''+u); return oo.apply(this,arguments); };
    XMLHttpRequest.prototype.send=function(){ var xx=this; try{ if(/\/cart\/add/i.test(xx.__apu||'')) xx.addEventListener('load',function(){ setTimeout(celebrate,50); }); }catch(e){} return os.apply(this,arguments); };
  }catch(e){}
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest)return;
    var b=t.closest('button, a, input[type="submit"], [role="button"]'); if(!b)return;
    var txt=((b.textContent||b.value||'')+'').toLowerCase();
    var m=(b.matches && b.matches('.product-form__submit, .product-form__buttons button[name="add"], #ap-sticky button, button[name="add"], [data-add-to-cart], .add-to-cart')) || /add to (cart|bag)/.test(txt);
    if(m && !b.disabled && b.getAttribute('aria-disabled')!=='true') setTimeout(celebrate,400);
  },true);
})();
